import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    term: "", // Wat de user intyped 
    termSearch: "", // Wat daadwerkelijk gebruikt wordt om te zoeken (lengte > 3 tekens bijvoorbeeld)
    results: "",
    clickedSearchButton: false
  },

  mutations: {
    updateTerm(state, payload) {
      state.term = payload;
    },
    updateTermSearch(state, payload) {
      state.termSearch = payload;
    },
    incrementClickedSearchButton(state) {
      state.clickedSearchButton++;
    },

  },

  getters: {
    term: state => state.term,
    termSearch: state => state.termSearch,
    clickedSearchButton: state => state.clickedSearchButton,
  }
}); // end Store
